import { render, staticRenderFns } from "./CandidatePlaceholder.vue?vue&type=template&id=77e3cadf&scoped=true&"
import script from "./CandidatePlaceholder.vue?vue&type=script&lang=js&"
export * from "./CandidatePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePlaceholder.vue?vue&type=style&index=0&id=77e3cadf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3cadf",
  null
  
)

export default component.exports